export default "__VITE_ASSET__Xu8kSai1__"